module.exports = __webpack_public_path__ + "media/images/nabor_gymskolka-1ae404d70ec9e7e0d3968faa00835a8e.jpg";